<div [ngClass]="this.temaPadrao" *ngIf="utilizaPesquisaAvancada">
    <mat-toolbar class="toolbar-detalhado" color="primary">
        <mat-toolbar-row>
            <button mat-icon-button (click)="fechar()">
                <mat-icon>keyboard_backspace</mat-icon>
            </button>
            <span class="titulo">Consulta por Veículos</span>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-card appearance="outlined">
        <mat-card-content class="filtros">
            <div *ngIf="utilizaFraga">
                <form>
                    <div class="form-row">
                        <mat-form-field class="mat-form-field">
                        <mat-label>Placa</mat-label>
                        <input matInput [formControl]="placaControl" type="text" />
                        </mat-form-field>
                    </div>
                </form>
            </div>

            <app-pesquisa-avancada-customizada #montadoraComp class="filtro" [labelDaDescricao]="'Montadora'" [identificador]="'cntMontadora'"
                [campoFiltro]="'NM_MONTADORA'" [lookupExibicao]="['CD_MONTADORA', 'NM_MONTADORA']"
                complementoConsulta="" [disabled]="false" [campoChaveDoFiltro]="'CD_MONTADORA'"
                [itemInicial]="consultaDetalhada.montadora" [possuiItemInicial]="consultaDetalhada.montadora"
                (itemCosulta)="receberItemConsultaMontadora($event)" [listaInicial]="">
            </app-pesquisa-avancada-customizada>

            <app-pesquisa-avancada-customizada #modeloComp class="filtro" [labelDaDescricao]="'Modelo'" [identificador]="'cntModelo'"
                [campoFiltro]="'NM_MODELO'" [lookupExibicao]="['CD_MODELO', 'NM_MODELO']"
                complementoConsulta="cd_montadora = {{consultaDetalhada.montadora}}"
                [disabled]="!consultaDetalhada.montadora" [campoChaveDoFiltro]="'CD_MODELO'"
                [itemInicial]="consultaDetalhada.modelo" [possuiItemInicial]="consultaDetalhada.modelo"
                (itemCosulta)="receberItemConsultaModelo($event)">
            </app-pesquisa-avancada-customizada>

            <app-pesquisa-avancada-customizada #complementoComp class="filtro" [labelDaDescricao]="'Complemento'" [identificador]="'cntVeiculoCompl'"
                [campoFiltro]="'NM_COMPLEMENTO'" [lookupExibicao]="['CD_COMPLEMENTO', 'NM_COMPLEMENTO']"
                complementoConsulta="CD_COMPLEMENTO IN (SELECT CD_COMPLEMENTO FROM VEICULO_MODELO_COMPLEMENTO WHERE CD_MODELO = {{consultaDetalhada?.modelo}});" 
                [campoChaveDoFiltro]="'CD_COMPLEMENTO'"
                [itemInicial]="consultaDetalhada.complemento" [possuiItemInicial]="consultaDetalhada.complemento"
                [disabled]="!consultaDetalhada.modelo"
                (itemCosulta)="receberItemConsultaComplemento($event)">
            </app-pesquisa-avancada-customizada>

            <mat-form-field class="filtro">
                <mat-label>Ano</mat-label>
                <input matInput type="text" [value]="consultaDetalhada.anoInicial ? consultaDetalhada.anoInicial : ''" 
                    [matAutocomplete]="auto" [disabled]="!consultaDetalhada.modelo"/>
                <button mat-icon-button matSuffix (click)="this.trigger.openPanel();" type="button" [disabled]="!consultaDetalhada.modelo">
                    <mat-icon>arrow_drop_down</mat-icon>
                </button>
                <mat-autocomplete #auto="matAutocomplete">
                    <mat-option *ngFor="let ano of anos" (click)="receberItemConsultaAno(ano)">
                        {{ ano }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <app-pesquisa-avancada-customizada #injecaoComp class="filtro" [labelDaDescricao]="'Injeção'" [identificador]="'cntVeiculoInjecao'"
                [campoFiltro]="'NM_INJECAO'" [lookupExibicao]="['CD_INJECAO', 'NM_INJECAO']"
                complementoConsulta="CD_INJECAO IN (
                    SELECT CD_INJECAO 
                    FROM VEICULO_MODELO_INJECAO
                    WHERE CD_MODELO = {{consultaDetalhada.modelo}}
                );" 
                [disabled]="!consultaDetalhada.modelo" [campoChaveDoFiltro]="'CD_INJECAO'"
                [itemInicial]="consultaDetalhada.injecao" [possuiItemInicial]="consultaDetalhada.injecao"
                (itemCosulta)="receberItemConsultaInjecao($event)">
            </app-pesquisa-avancada-customizada>

            <app-pesquisa-avancada-customizada #motorComp class="filtro" [labelDaDescricao]="'Motor'" [identificador]="'cntVeiculoMotor'"
                [campoFiltro]="'NM_MOTOR'" [lookupExibicao]="['CD_MOTOR', 'NM_MOTOR']"
                complementoConsulta="CD_MOTOR IN (
                    SELECT CD_MOTOR 
                    FROM VEICULO_MODELO_MOTOR
                    WHERE CD_MODELO = {{consultaDetalhada.modelo}}
                );" 
                [disabled]="!consultaDetalhada.modelo" [campoChaveDoFiltro]="'CD_MOTOR'"
                [itemInicial]="consultaDetalhada.motor" [possuiItemInicial]="consultaDetalhada.motor"
                (itemCosulta)="receberItemConsultaMotor($event)">
            </app-pesquisa-avancada-customizada>

            <app-pesquisa-avancada-customizada #transmissaoComp class="filtro" [labelDaDescricao]="'Transmissão'" [identificador]="'cntVeiculoTrans'"
                [campoFiltro]="'NM_TRANSMISSAO'" [lookupExibicao]="['CD_TRANSMISSAO', 'NM_TRANSMISSAO']"
                complementoConsulta="CD_TRANSMISSAO IN (
                    SELECT CD_TRANSMISSAO 
                    FROM VEICULO_MODELO_TRANSMISSAO
                    WHERE CD_MODELO = {{consultaDetalhada.modelo}}
                );"  
                [disabled]="!consultaDetalhada.modelo" [campoChaveDoFiltro]="'CD_TRANSMISSAO'"
                [itemInicial]="consultaDetalhada.transmissao" [possuiItemInicial]="consultaDetalhada.transmissao"
                (itemCosulta)="receberItemConsultaTransmissao($event)">
            </app-pesquisa-avancada-customizada>
        </mat-card-content>

        <div class="clear-button-container">
            <button class="botao-filtrar" mat-raised-button color="primary" (click)="aplicarFiltros()">Filtrar
                <mat-icon>filter_list</mat-icon>
            </button>
            <button mat-raised-button color="accent" (click)="limparFiltros()">Limpar Filtros</button>
        </div>
    </mat-card>
</div>
